<template>
  <div class="animated fadeIn">
    <b-alert :variant="alertVariant" dismissible :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ message }}
    </b-alert>

    <b-row style="border: 1px dashed black; margin: 10px">
      <b-col style="padding: 10px">
        <h5>Send Push Notification</h5>
        <b-row>
          <b-col md="4">
            <label>Title</label>
            <input type="text" class="form-control" v-model="form.title">
          </b-col>
          <b-col md="8">
            <label>Message</label>
            <input type="text" class="form-control" v-model="form.body">
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col md="2">
            <label>Blast</label>
            <div>
              <input type="checkbox" v-model="form.blast">
            </div>
          </b-col>
          <b-col md="10">
            <label>Search Customer/User</label>
            <input type="text" class="form-control" v-model="userSearch" :disabled="form.blast"
                   placeholder="Search company, customer account, email, phone, or status">
          </b-col>
        </b-row>
        <br>
        <b-row v-if="!form.blast">
          <b-col>
            <div class="notification-selection-bar">
              <span>{{ selectedEmails.length }} selected</span>
              <button type="button" class="btn btn-sm btn-secondary" @click="selectPageUsers()" :disabled="loading || pagedUsers.length === 0">
                Select Page
              </button>
              <button type="button" class="btn btn-sm btn-secondary" @click="clearSelectedUsers()" :disabled="loading || selectedEmails.length === 0">
                Clear
              </button>
              <button type="button" class="btn btn-sm btn-primary" @click="refreshUsers()" :disabled="loading">
                Refresh Users
              </button>
            </div>
            <b-table class="notification-user-table" small bordered hover :items="pagedUsers" :fields="userFields"
                     @row-clicked="toggleUser">
            </b-table>
            <b-pagination v-model="userCurrentPage" :total-rows="filteredUsers.length"
                          :per-page="usersPerPage" align="right"></b-pagination>
          </b-col>
        </b-row>
        <br>
        <button type="button" class="btn btn-primary" @click="sendNotification()" :disabled="loading">Send</button>
        <button type="button" class="btn btn-primary" @click="refreshLogs()" :disabled="loading">Refresh Logs</button>
      </b-col>
    </b-row>

    <b-row style="border: 1px dashed black; margin: 10px">
      <b-col style="padding: 10px">
        <h5>Invoice Upload Notification Settings</h5>
        <b-row>
          <b-col md="2">
            <label>Enabled</label>
            <div>
              <input type="checkbox" v-model="settingsForm.enabled">
            </div>
          </b-col>
          <b-col md="4">
            <label>Title</label>
            <input type="text" class="form-control" v-model="settingsForm.title">
          </b-col>
          <b-col md="6">
            <label>Message</label>
            <input type="text" class="form-control" v-model="settingsForm.body">
          </b-col>
        </b-row>
        <br>
        <button type="button" class="btn btn-primary" @click="saveInvoiceEligibleSettings()" :disabled="loading">Save Settings</button>
      </b-col>
    </b-row>

    <b-modal v-model="showConfirmModal" title="Confirm Push Notification" @ok="confirmSendNotification">
      <p><b>Title:</b> {{ form.title }}</p>
      <p><b>Message:</b> {{ form.body }}</p>
      <p v-if="form.blast"><b>Send To:</b> All registered notification devices</p>
      <div v-else>
        <p><b>Send To:</b> {{ selectedCustomerDetails.length }} customer(s)</p>
        <div class="notification-confirm-list">
          <div v-for="customer in selectedCustomerDetails" :key="customer.email">
            {{ customer.companyName || '-' }} / {{ customer.accountNumber || '-' }} / {{ customer.email }}
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="showLogDetailModal" title="Notification Log Details" size="lg" ok-only>
      <div v-if="selectedLog">
        <p><b>Created:</b> {{ selectedLog.createdDate }}</p>
        <p><b>Title:</b> {{ selectedLog.title }}</p>
        <p><b>Message:</b> {{ selectedLog.body }}</p>
        <p><b>Status:</b> {{ selectedLog.status }}</p>
        <p><b>Success:</b> {{ selectedLog.successCount }} <b>Failure:</b> {{ selectedLog.failureCount }}</p>
        <p><b>Sent To:</b> {{ selectedLog.recipients || '-' }}</p>

        <div v-if="selectedLog.responses && selectedLog.responses.length > 0">
          <h6>Successful Recipients</h6>
          <b-table small bordered :items="successfulLogResponses" :fields="responseFields"></b-table>

          <h6>Failed Recipients</h6>
          <b-table small bordered :items="failedLogResponses" :fields="responseFields"></b-table>
        </div>
        <div v-else>
          <p>This log was created before per-recipient response details were stored, or no tokens were found.</p>
        </div>
      </div>
    </b-modal>

    <b-table small bordered hover :items="pagedLogs" :fields="logFields">
      <template slot="details" slot-scope="row">
        <button type="button" class="btn btn-sm btn-primary" @click="openLogDetail(row.item)">View</button>
      </template>
    </b-table>
    <b-pagination v-model="logCurrentPage" :total-rows="logs.length"
                  :per-page="logsPerPage" align="right"></b-pagination>

    <img src="static/img/Rolling.svg" alt="Loading data..."
         style="margin-left:auto; margin-right:auto; display: block;"
         v-if="loading">
  </div>
</template>

<script>
export default {
  name: 'Notifications',
  data () {
    return {
      selectedEmails: [],
      userCurrentPage: 1,
      usersPerPage: 10,
      logCurrentPage: 1,
      logsPerPage: 10,
      showConfirmModal: false,
      showLogDetailModal: false,
      selectedLog: null,
      responseFields: [
        { key: 'email', label: 'Customer Email' },
        { key: 'platform', label: 'Platform' },
        { key: 'messageId', label: 'Message ID' },
        { key: 'error', label: 'Error' }
      ],
      userSearch: '',
      form: {
        title: '',
        body: '',
        blast: false
      },
      settingsForm: {
        enabled: false,
        title: '',
        body: ''
      }
    }
  },
  created: function () {
    this.$store.dispatch('notifmod/fetchLogs')
    this.$store.dispatch('notifmod/fetchUsers')
    this.$store.dispatch('notifmod/fetchInvoiceEligibleSettings')
  },
  watch: {
    userSearch: function () {
      this.userCurrentPage = 1
    },
    invoiceEligibleSettings: {
      handler: function (settings) {
        this.settingsForm = Object.assign({}, settings)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    users: function () {
      return this.$store.state.notifmod.users
    },
    userFields: function () {
      return this.$store.getters['notifmod/userFields']
    },
    filteredUsers: function () {
      let search = this.userSearch.trim().toLowerCase()
      let users = search
        ? this.users.filter(function (user) {
          return (user.companyName || '').toLowerCase().indexOf(search) !== -1 ||
            (user.accountNumber || '').toLowerCase().indexOf(search) !== -1 ||
            (user.email || '').toLowerCase().indexOf(search) !== -1 ||
            (user.phoneNumber || '').toLowerCase().indexOf(search) !== -1 ||
            (user.status || '').toLowerCase().indexOf(search) !== -1
        })
        : this.users

      return users.map(function (user) {
        let row = Object.assign({}, user)
        row._rowVariant = this.isUserSelected(user.email) ? 'info' : ''
        return row
      }.bind(this))
    },
    pagedUsers: function () {
      let start = (this.userCurrentPage - 1) * this.usersPerPage
      return this.filteredUsers.slice(start, start + this.usersPerPage)
    },
    selectedCustomerDetails: function () {
      let selectedMap = {}
      this.selectedEmails.forEach(function (email) {
        selectedMap[email] = true
      })
      return this.users.filter(function (user) {
        return selectedMap[user.email]
      })
    },
    logs: function () {
      return this.$store.state.notifmod.logs
    },
    invoiceEligibleSettings: function () {
      return this.$store.state.notifmod.invoiceEligibleSettings
    },
    pagedLogs: function () {
      let start = (this.logCurrentPage - 1) * this.logsPerPage
      return this.logs.slice(start, start + this.logsPerPage)
    },
    successfulLogResponses: function () {
      if (!this.selectedLog || !this.selectedLog.responses) {
        return []
      }
      return this.selectedLog.responses.filter(function (response) {
        return response.success === true
      })
    },
    failedLogResponses: function () {
      if (!this.selectedLog || !this.selectedLog.responses) {
        return []
      }
      return this.selectedLog.responses.filter(function (response) {
        return response.success !== true
      })
    },
    logFields: function () {
      return this.$store.getters['notifmod/logFields']
    },
    loading: function () {
      return this.$store.state.notifmod.loading
    },
    alertVariant: function () {
      return this.$store.state.notifmod.alertVariant
    },
    showDismissibleAlert: {
      get: function () {
        return this.$store.state.notifmod.showDismissibleAlert
      },
      set: function (dismiss) {
        this.$store.commit('notifmod/closeDismissibleAlert', dismiss)
      }
    },
    message: function () {
      return this.$store.state.notifmod.message
    }
  },
  methods: {
    isUserSelected: function (email) {
      return this.selectedEmails.indexOf(email) !== -1
    },
    toggleUser: function (user) {
      if (!user || !user.email) {
        return
      }
      let index = this.selectedEmails.indexOf(user.email)
      if (index === -1) {
        this.selectedEmails.push(user.email)
      } else {
        this.selectedEmails.splice(index, 1)
      }
    },
    selectPageUsers: function () {
      let selectedMap = {}
      this.selectedEmails.forEach(function (email) {
        selectedMap[email] = true
      })
      this.pagedUsers.forEach(function (user) {
        if (user.email) {
          selectedMap[user.email] = true
        }
      })
      this.selectedEmails = Object.keys(selectedMap)
    },
    clearSelectedUsers: function () {
      this.selectedEmails = []
    },
    sendNotification: function () {
      let emails = this.selectedEmails.slice()

      if (!this.form.title || !this.form.body) {
        this.$store.commit('notifmod/showAlert', { variant: 'danger', message: 'Title and message are required.' })
        return
      }

      if (!this.form.blast && emails.length === 0) {
        this.$store.commit('notifmod/showAlert', { variant: 'danger', message: 'Select at least one customer or choose Blast.' })
        return
      }

      this.showConfirmModal = true
    },
    confirmSendNotification: function () {
      let emails = this.selectedEmails.slice()
      this.$store.dispatch('notifmod/sendNotification', {
        title: this.form.title,
        body: this.form.body,
        blast: this.form.blast,
        emails: emails
      })
    },
    openLogDetail: function (log) {
      this.selectedLog = log
      this.showLogDetailModal = true
    },
    refreshUsers: function () {
      this.$store.dispatch('notifmod/fetchUsers')
    },
    refreshLogs: function () {
      this.$store.dispatch('notifmod/fetchLogs')
    },
    saveInvoiceEligibleSettings: function () {
      if (!this.settingsForm.title || !this.settingsForm.body) {
        this.$store.commit('notifmod/showAlert', { variant: 'danger', message: 'Invoice notification title and message are required.' })
        return
      }
      this.$store.dispatch('notifmod/saveInvoiceEligibleSettings', this.settingsForm)
    }
  }
}
</script>

<style>
.notification-selection-bar {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.notification-user-table tbody tr {
  cursor: pointer;
}

.notification-user-table tbody tr.table-info td:first-child::before {
  content: 'Selected';
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  margin-right: 8px;
  text-transform: uppercase;
}

.notification-confirm-list {
  border: 1px solid #d8dbe0;
  max-height: 220px;
  overflow: auto;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Notifications.vue